export const CustomerTerms = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-background text-foreground">
      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-4">Terms of Service for Customers</h1>
        <p className="text-sm text-muted-foreground mb-2">
          <strong>Company:</strong> Realise Property Maintenance Ltd. trading as "Sortable"
        </p>
        <p className="text-sm text-muted-foreground mb-2">
          <strong>Address:</strong> 13 Harbury Rd. Henleaze Business Centre, Henleaze, Bristol, BS9 4PN
        </p>
        <p className="text-sm text-muted-foreground mb-4">
          <strong>Telephone:</strong> 08000438880
        </p>
        <p className="text-sm text-muted-foreground">
          <strong>Last Updated:</strong> {new Date().toLocaleDateString()}
        </p>
      </div>

      <div className="space-y-6">
        <section>
          <h2 className="text-xl font-semibold mb-3">1. Service Overview</h2>
          <p className="mb-3">
            Sortable connects customers with qualified tradespeople for property maintenance 
            and repair services. We act as an intermediary platform and are not directly 
            responsible for the work performed by tradespeople.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">2. Creating Job Requests</h2>
          <div className="space-y-2">
            <p>2.1. You must provide accurate and complete job descriptions</p>
            <p>2.2. Include all relevant details including access requirements</p>
            <p>2.3. Specify your budget range and preferred timeframe</p>
            <p>2.4. Upload clear photos where possible to help tradespeople understand the work</p>
            <p>2.5. You must have the legal right to request work on the property</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">3. Selecting Tradespeople</h2>
          <div className="space-y-2">
            <p>3.1. Review tradesperson profiles, ratings, and qualifications carefully</p>
            <p>3.2. Compare quotes and ask questions before making a selection</p>
            <p>3.3. Ensure the tradesperson has appropriate insurance and qualifications</p>
            <p>3.4. Once you accept a quote, you are committed to proceeding with that tradesperson</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">4. Property Access and Safety</h2>
          <div className="space-y-2">
            <p>4.1. You must provide safe and reasonable access to the work area</p>
            <p>4.2. Inform tradespeople of any known hazards or special requirements</p>
            <p>4.3. Ensure pets and children are kept safe during work</p>
            <p>4.4. You may be present during work but must not interfere with safety procedures</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">5. Payment Obligations</h2>
          <div className="space-y-2">
            <p>5.1. Payment terms are agreed directly with the tradesperson</p>
            <p>5.2. Payment is typically due upon satisfactory completion of work</p>
            <p>5.3. You may be required to pay for materials in advance for large jobs</p>
            <p>5.4. Dispute any charges promptly and in good faith</p>
            <p>5.5. We may charge service fees as displayed on our platform</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">6. Quality and Warranties</h2>
          <div className="space-y-2">
            <p>6.1. Tradespeople are responsible for the quality of their work</p>
            <p>6.2. Most work comes with statutory warranties under consumer protection law</p>
            <p>6.3. Report any issues with work quality promptly</p>
            <p>6.4. We provide dispute resolution services for quality issues</p>
            <p>6.5. Keep records of all work performed and payments made</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">7. Cancellation Policy</h2>
          <div className="space-y-2">
            <p>7.1. You may cancel jobs before work begins with reasonable notice</p>
            <p>7.2. Cancellation fees may apply if materials have been ordered</p>
            <p>7.3. Emergency or safety-related cancellations are exempt from fees</p>
            <p>7.4. Repeated cancellations may result in account restrictions</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">8. Reviews and Ratings</h2>
          <div className="space-y-2">
            <p>8.1. Please provide honest and constructive reviews of completed work</p>
            <p>8.2. Reviews should be based on work quality, professionalism, and timeliness</p>
            <p>8.3. Do not include personal information in reviews</p>
            <p>8.4. Fake or malicious reviews will be removed and may result in account suspension</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">9. Insurance and Liability</h2>
          <div className="space-y-2">
            <p>9.1. Tradespeople must carry appropriate public liability insurance</p>
            <p>9.2. We are not liable for damage caused by tradespeople</p>
            <p>9.3. Report any damage or accidents immediately</p>
            <p>9.4. Consider your own insurance coverage for major works</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">10. Prohibited Uses</h2>
          <div className="space-y-2">
            <p>10.1. Using the platform for illegal activities</p>
            <p>10.2. Circumventing the platform to avoid fees</p>
            <p>10.3. Providing false information about jobs or requirements</p>
            <p>10.4. Harassment or inappropriate behavior toward tradespeople</p>
            <p>10.5. Creating multiple accounts to avoid restrictions</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">11. Dispute Resolution</h2>
          <div className="space-y-2">
            <p>11.1. Contact us immediately if issues arise with tradespeople</p>
            <p>11.2. We offer mediation services for disputes</p>
            <p>11.3. Provide documentation and evidence to support complaints</p>
            <p>11.4. Serious issues may be escalated to relevant trade bodies</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">12. Data Protection</h2>
          <p className="mb-3">
            Your personal information is processed in accordance with our Privacy Policy. 
            Tradespeople will have access to necessary contact and job information to provide services.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">13. Contact Information</h2>
          <div className="space-y-2">
            <p>For questions about these terms, please contact us:</p>
            <p><strong>Email:</strong> customers@sortable.co.uk</p>
            <p><strong>Phone:</strong> 08000438880</p>
            <p><strong>Address:</strong> 13 Harbury Rd. Henleaze Business Centre, Henleaze, Bristol, BS9 4PN</p>
          </div>
        </section>
      </div>
    </div>
  );
};